import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { errorHandler, getContent } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import API_MASTER_DATA from '../../../api/apiMasterData';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_SHIFT_UPDATE, MASTER_DATA_SHIFT_VIEW } from '../../../constants/menuPermissionConstant';

class ShiftDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shiftDetail: {}
        }
    }

    getDetailShift = () => {
        API_MASTER_DATA.getDetailShift(this.props.match.params.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        shiftDetail: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleRedirectListShift = () => {
        this.props.history.goBack();
    }

    handleRedirectEditShift = value => {
        this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_SHIFT_EDIT.split(':')[0] + value.id);
    }

    componentDidMount() {
        this._isMounted = true;

        this.getDetailShift();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const shift = this.state.shiftDetail;

        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_SHIFT_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Shift"
                        title="Detail Shift"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-ticket bg-white border border-gray-300 rounded-lg px-6 py-10">
                            <div className="w-1/2 space-y-6">
                                <div className="w-1/2">
                                    <p className="text-nexcaregray1 text-sm">Nama Shift</p>
                                    <p className="text-nexcareblack2 font-medium">{shift.shift_name}</p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcaregray1 text-sm">Deskripsi</p>
                                    <p className="text-nexcareblack2 font-medium">{shift.shift_description}</p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcaregray1 text-sm">Jam Mulai</p>
                                    <p className="text-nexcareblack2 font-medium">{shift.work_start ? shift.work_start : '-'}</p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcaregray1 text-sm">Jam Selesai</p>
                                    <p className="text-nexcareblack2 font-medium">{shift.work_end ? shift.work_end : '-'}</p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcaregray1 text-sm">Jam Istirahat Mulai</p>
                                    <p className="text-nexcareblack2 font-medium">{shift.break_start ? shift.break_start : '-'}</p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcaregray1 text-sm">Jam Istirahat Selesai</p>
                                    <p className="text-nexcareblack2 font-medium">{shift.break_end ? shift.break_end : '-'}</p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcaregray1 text-sm">Tanggal Pembuatan</p>
                                    <p className="text-nexcareblack2 font-medium">{moment.utc(shift.created_at).format('DD/MM/YYYY | HH:mm')}</p>
                                </div>
                                <div className="w-1/2">
                                    <p className="text-nexcaregray1 text-sm">Dibuat Oleh</p>
                                    <p className="text-nexcareblack2 font-medium">{shift.created_by_user}</p>
                                </div>
                            </div>
                        </div>

                        {/* Action Button */}
                        <div className="flex flex-row-reverse">
                            <div className="space-x-3 pt-3">
                                <ButtonBorderNexcareDefault onClick={() => this.handleRedirectListShift()}>
                                    Batal
                                </ButtonBorderNexcareDefault>
                                <CheckPermissionComponent permissionConstant={[MASTER_DATA_SHIFT_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                    <ButtonNexcareDefault onClick={() => this.handleRedirectEditShift(shift)}>
                                        Ubah
                                    </ButtonNexcareDefault>
                                </CheckPermissionComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftDetail);